<template>
  <el-dialog title="编辑" :visible.sync="formVisible" width="800px" :close-on-click-modal="false" v-if="formVisible">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">
      <el-form-item label="配置名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入配置名称" disabled />
      </el-form-item>
      <el-form-item label="默认配置" prop="content" v-if="form.code === 'order_is_open_remark'">
        <el-radio-group v-model="form.content">
          <el-radio label="1">允许备注</el-radio>
          <el-radio label="0">不允许备注</el-radio>
        </el-radio-group>
        <br />
        <span class="">允许备注，APP端客户下单才可以看到备注选项</span>
      </el-form-item>
      <el-form-item label="默认配置" prop="content" v-if="form.code === 'meetFeeReundMethod'">
        <el-radio-group v-model="form.content">
          <el-radio label="10">原路退回</el-radio>
          <el-radio label="20">余额退回</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="默认配置" prop="content" v-if="form.code === 'setCourse' || form.code === 'homeRecommendedCourse' || form.code === 'onlineSituationalPracticeAnswer' || form.code === 'SituationalPracticeAnswer'">
        <el-radio-group v-model="form.content">
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="默认配置" prop="content" v-else-if="isMeetingBoolean">
        <el-radio-group v-model="form.content">
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="配置内容" prop="content" v-else-if="returnTextarea">
        <el-input v-model="form.content" type="textarea" :rows="4" placeholder="请输入内容" />
      </el-form-item>
      <el-form-item label="配置内容" prop="content" v-else-if="returnEditor">
        <editor v-model="form.content" :min-height="240" :height="240" :uploadUrl="uploadUrl" />
      </el-form-item>
      <el-form-item label="配置文档" prop="content" v-else-if="form.code === 'contractTemplate'">
        <fileUpload v-model="form.content" hintText="请上传word格式的文档" @input="inputFile" />
      </el-form-item>
      <el-form-item label="配置图片" prop="content" v-else-if="form.code === 'coursewarePictureWatermark'">
        <fileUpload v-model="form.content" hintText="请上传图片" @input="inputFile" />
      </el-form-item>
      <el-form-item label="水印位置" class="location" v-else-if="form.code === 'WatermarkPosition'">
        <el-radio-group v-model="form.content">
          <el-radio :label="item.value" v-for="(item,index) in locationOptions" :key="index">#{{item.name}}</el-radio>
        </el-radio-group>

      </el-form-item>
      <el-form-item label="配置图片(359*129)" prop="content" v-else-if="form.code === 'HomeLiveBigPicture'">
        <fileUpload v-model="form.content" hintText="请上传图片" @input="inputFile" />
      </el-form-item>
      <el-form-item label="配置图片" prop="content" v-else-if="form.code === 'MarketingPotentialShare'">
        <moreImageUpload v-model="marketingImages" :limit="9" hintText="支持上传多张图片" />
      </el-form-item>
      <el-form-item label="配置内容" v-else-if="buyPermission || lookPermission" required>
        <div v-for="(item,index) in calccustomerLevel" class="lab" :key="index" :class="{'active': item.isActive}" @click="handleActive(item)">
          <i class="el-icon-success" v-if="item.isActive"></i>{{item.name}}
        </div>
        <template v-if="lookPermission">
          <div class="lab" :class="{'active': item.isActive}" v-for="(item,index) in options.registerRole" :key="index" @click="handleActive(item)">
            <i class="el-icon-success" v-if="item.isActive"></i>{{item.value}}
          </div>
          <div class="lab" :class="{'active': item.isActive}" v-for="(item,index) in options.technicalServiceLevel" :key="index" @click="handleActive(item)">
            <i class="el-icon-success" v-if="item.isActive"></i>{{item.value}}
          </div>
        </template>
      </el-form-item>
      <template v-else-if="returnAddress">
        <el-form-item label="收货人" prop="content">
          <el-input v-model="form.content" placeholder="请输入内容，请用逗号隔开" />
        </el-form-item>
        <el-form-item label="收货地址" prop="content1">
          <el-input v-model="form.content1" placeholder="请输入内容，请用逗号隔开" />
        </el-form-item>
      </template>
      <template v-else-if="isGoodsGift">
        <el-form-item label="配置内容" prop="content">
          <el-cascader v-model="selectedGoodsSpec" filterable :options="goodsCascaderList" placeholder="请选择商品及规格" clearable @expand-change="handleExpandChange" />
        </el-form-item>
      </template>
      <template v-else-if="form.code === 'goodsCategoryForIP'">
        <el-form-item label="配置内容" prop="content">
          <el-cascader v-model="form.content" :options="categorizeOptions" :props="categorizepProps" collapse-tags clearable placeholder="请选择IP商品分类"></el-cascader>
        </el-form-item>
      </template>
      <el-form-item label="默认配置" prop="content" v-else-if="form.code === 'changAddRegistrationGift'">
        <el-radio-group v-model="form.content">
          <el-radio label="0">下单客户手动发货</el-radio>
          <el-radio label="1">自动发货</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="配置内容" prop="content" v-else-if="form.code !== 'open_share'">
        <el-input v-model="form.content" placeholder="请输入内容，请用逗号隔开" />
      </el-form-item>
      <el-form-item label="配置内容" v-else>
        <el-input v-model="form.content" placeholder="请输入内容，请用逗号隔开" />
      </el-form-item>
      <el-form-item label="单位" prop="content1" v-if="isUnit">
        <el-select v-model="form.content1" :disabled="isDisable" placeholder="请选择单位">
          <el-option label="分钟" value="分钟"></el-option>
          <el-option label="小时" value="小时"></el-option>
          <el-option label="天" value="天"></el-option>
          <el-option label="倍" value="倍"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-switch v-model="form.isEnable" :active-value="true" :inactive-value="false"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import Editor from "@/components/Editor";
import FileUpload from "@/components/FileUpload";
import MoreImageUpload from "@/components/MoreImageUpload";
import sysRoleApi from '@/api/sys/sysRole'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import customerLevelApi from '@/api/sys/customerLevel'
// import registerRoleApi from '@/api/sys/registerRole'
import technicalServiceLevelApi from '@/api/sys/technicalServiceLevel'
import sysGoodsApi from '@/api/sys/sysGoods'
import sysGoodsCategorizeApi from '@/api/goods/sysGoodsCategorize'
function initFormBean() {
  const formBean = {
    name: null,
    content: null,
    content1: null,
    content2: null,
    content3: null,
    content4: null,
    isEnable: false,
  }
  return formBean
}

export default {
  components: { Editor, FileUpload, MoreImageUpload },
  data() {
    return {
      categorizepProps: {
        label: 'name',
        value: 'id',
        children: 'child',
        multiple: true
      },
      uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload',
      form: initFormBean(),
      formVisible: false,
      formRules: {
        name: [{ required: true, message: '请输入配置名称', trigger: 'blur' }],
        content: [{ required: true, message: '请输入配置内容', trigger: 'blur' }],
        // content1: [{ required: true, message: '请选择单位', trigger: 'change' }],
      },
      options: {
        customerLevel: [],  //   业务线-客户级别
        registerRole: [],   //职能线-用户角色
        technicalServiceLevel: []  //技术线-技术线级别
      },
      locationOptions: [{ value: 1, name: '左上' }, { value: 2, name: '中上' }, { value: 3, name: '右上' }, { value: 4, name: '左中' }
        , { value: 5, name: '居中' }, { value: 6, name: '右中' }, { value: 7, name: '左下' }, { value: 8, name: '中下' }, { value: 9, name: '右下' }],
      goodsList: [],
      goodsCascaderList: [], // 级联选择器数据
      selectedGoodsSpec: [], // 选中的 [商品id, 规格id]
      categorizeOptions: [],  //商品分类
      marketingImages: [], // MarketingPotentialShare 多图片
    }
  },
  created() {
    customerLevelApi.fetchList().then(({ data }) => { this.options.customerLevel = data })
    sysRoleApi.fetchList({ pageNo: 1, pageSize: 1000, roleType: 2 }).then(({ data }) => {
      let arr = []
      data.list.forEach(item => {
        arr.push({ value: item.roleName, key: item.id })
      })
      this.options.registerRole = arr
    })
    technicalServiceLevelApi.findOptions().then(({ data }) => { this.options.technicalServiceLevel = data })
    this.getGoods()

  },
  computed: {
    isGoodsGift() {
      let { code } = this.form;
      if (code === 'upyanxiubansendgood' || code === 'uptiyanbansendgood' || code === 'tyupxybansendgood') return true
      else false
    },
    isDisable() {
      let { code } = this.form;
      if (code === 'order_point_cancel_time' || code === 'order_cancel_time') return true
      else false
    },
    calccustomerLevel() {
      let { customerLevel } = this.options;
      let filteredObjects = customerLevel
      let { code } = this.form;
      if (code === 'product_seckill_buy_auth' || code === 'product_point_buy_auth') {
        const neededIds = [6, 7];
        filteredObjects = customerLevel.filter(obj => neededIds.includes(obj.id));
      }
      if (code === 'product_buy_auth') {
        const neededIds = [3, 4, 5, 6, 7];
        filteredObjects = customerLevel.filter(obj => neededIds.includes(obj.id));
      }
      return filteredObjects

    },
    isUnit() {
      let { code } = this.form;
      if (code === 'order_cancel_time' || code === 'order_auto_sign_time' || code === 'order_point_cancel_time' || code === 'pre_sale_delivery_time' ||
        code === 'x_d_coin_freight_Proportion' || code === 'gifts_quota_freight_Proportion' || code === 'x_d_coin_goods_price') return true
      else false
    },
    buyPermission() {
      let { code } = this.form;
      if (code === 'product_buy_auth' || code === 'product_point_buy_auth' || code === 'product_seckill_buy_auth') return true
      else false
    },
    lookPermission() {
      let { code } = this.form;
      if (code === 'product_price_auth' || code === 'product_point_price_auth' || code === 'product_seckill_price_auth') return true
      else false
    },
    returnAddress() {
      let { code } = this.form;
      if (code === 'after_sales_return_address') return true
      else false
    },
    returnTextarea() {
      let { code } = this.form;
      if (code === 'rechargeDesc' || code === 'pointsRule' || code === 'toCashRule' || code === 'onlineServiceAppointmentDesc' || code === 'offlineServiceAppointmentDesc') return true
      else false
    },
    returnEditor() {
      let { code } = this.form;
      if (code === 'custFranchiseDescL7' || code === 'custFranchiseDescL6' || code === 'PrivacyAgreement' || code === 'ServiceAgreement' || code === 'meetingPingZhengJiaoCheng') return true
      else false
    },
    // 判断是否是布尔类型的会议配置
    isMeetingBoolean() {
      let { code } = this.form;
      if (code === 'meetingBaoMingZhuanPiao' || code === 'APPIsStartXianxia') return true
      else false
    },

  },
  methods: {
    getSelectOptions() {
      sysGoodsCategorizeApi.fetchTreeList({ pageNo: 1, pageSize: 1000, goodsAreaIds: '3,4,5', isEnable: true }).then(({ data }) => {
        this.categorizeOptions = this.formatCascaderData(data.list)
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    getGoods() {
      sysGoodsApi.getGoodRecomList({ isListing: 1 }).then(({ data }) => {
        this.goodsList = data
        // 生成级联数据
        this.goodsCascaderList = data.map(goods => ({
          value: goods.id,
          label: goods.name,
          goodsCode: goods.goodsCode,
          children: (goods.specValueList || []).map(spec => ({
            value: spec.id,
            label: spec.spec || '无规格值'
          }))
        }))
      })
    },
    handleExpandChange(val) {
      if (val && val.length === 1) {
        const parent = this.goodsCascaderList.find(item => item.value === val[0])
        if (parent && parent.children && parent.children.length === 1) {
          this.selectedGoodsSpec = [val[0], parent.children[0].value]
        }
      }
    },
    handleActive(item) {
      item.isActive = !item.isActive
      this.$forceUpdate();
    },
    resetForm() {
      this.$set(this.form, 'content', null)
      this.$set(this.form, 'content1', null)
      this.$set(this.form, 'content2', null)
      this.$set(this.form, 'content3', null)
      this.$set(this.form, 'content4', null)
      this.marketingImages = [];
    },
    async handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      if (this.buyPermission || this.lookPermission) {
        let content2 = row.content2 ? JSON.parse(this.form.content2) : null
        this.options.customerLevel.forEach(item => {
          let find = content2 && content2.customerLevel.find(it => it === item.id)
          item.isActive = find ? true : false
        })
        if (this.lookPermission) {
          this.options.registerRole.forEach(item => {
            let find = content2 && content2.registerRole.find(it => it === item.key)
            item.isActive = find ? true : false
          })
          this.options.technicalServiceLevel.forEach(item => {
            let find = content2 && content2.technicalServiceLevel.find(it => it === item.key)
            item.isActive = find ? true : false
          })
        }
      }
      if (row.code === 'contractTemplate' || row.code === 'coursewarePictureWatermark' || row.code === 'HomeLiveBigPicture') {
        this.form.content = row.content ? [{ url: row.content, name: row.content }] : []
      }
      if (row.code === 'WatermarkPosition') {
        this.form.content = row.content ? +row.content : ''
      }
      // 处理布尔类型的会议配置
      if (row.code === 'meetingBaoMingZhuanPiao' || row.code === 'APPIsStartXianxia') {
        // 确保 content 是字符串 "1" 或 "0"
        if (row.content === true || row.content === 'true' || row.content === 1 || row.content === '1') {
          this.form.content = '1'
        } else if (row.content === false || row.content === 'false' || row.content === 0 || row.content === '0') {
          this.form.content = '0'
        } else {
          this.form.content = row.content || '0'
        }
      }
      // 处理 changAddRegistrationGift 配置，确保 content 是字符串 "0" 或 "1"
      if (row.code === 'changAddRegistrationGift') {
        if (row.content === true || row.content === 'true' || row.content === 1 || row.content === '1') {
          this.form.content = '1'
        } else if (row.content === false || row.content === 'false' || row.content === 0 || row.content === '0') {
          this.form.content = '0'
        } else {
          this.form.content = row.content || '0'
        }
      }
      // 处理富文本类型的会议配置（meetingPingZhengJiaoCheng 已经在 returnEditor 中处理，会自动使用 editor 组件）
      if (row.code === 'upyanxiubansendgood' || row.code === 'uptiyanbansendgood' || row.code === 'tyupxybansendgood') {
        if (row.content) {
          const obj = JSON.parse(row.content)
          this.selectedGoodsSpec = [obj.id, obj.specId]
        } else {
          this.selectedGoodsSpec = []
        }
      }
      if (row.code === 'goodsCategoryForIP') {
        let {data} = await sysGoodsCategorizeApi.fetchTreeList({ pageNo: 1, pageSize: 1000, goodsAreaIds: '3,4,5', isEnable: true })
        this.categorizeOptions = this.formatCascaderData(data.list)
        let categorizeList = this.treeToList2(data.list)
        let categArr = []
        let contArr = row.content ? row.content.split(',').map(Number) : []
        contArr.forEach(item => {
          let find = categorizeList.find(it => it.id === item);
          if (find && find.parentid) {
            categArr.push([find.parentid, find.id])
          } else {
            if (find) categArr.push([find.id])
          }
        })
        this.$set(this.form, 'content', categArr);
      }
      // 处理 MarketingPotentialShare 多图片
      if (row.code === 'MarketingPotentialShare') {
        if (row.content) {
          // 按逗号分隔，转换为组件需要的格式 [{url: 'xxx', name: 'xxx'}]
          const urls = row.content.split(',').map(s => s.trim()).filter(Boolean);
          this.marketingImages = urls.map((url, index) => ({
            url: url,
            name: url.split('/').pop() || `image-${index}.png`
          }));
        } else {
          this.marketingImages = [];
        }
      }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    treeToList2(tree) {
      let node, result = tree.map(node => (node.level = 1, node))
      for (let i = 0; i < result.length; i++) {
        if (!result[i].child) continue
        let list = result[i].child.map(node => (node.level = result[i].level + 1, node))
        result.splice(i + 1, 0, ...list)
      }
      return result
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      let { isEnable, name, id, code, content, content1, content2, content3, content4, isDisplay } = this.form;
      let params = {
        id, code, name, isEnable, content, content1, content2, content3, content4, isDisplay
      }
      if (this.buyPermission || this.lookPermission) {
        let names = [], ids1 = [], ids2 = [], ids3 = [];
        this.options.customerLevel.forEach(item => {
          if (item.isActive) {
            ids1.push(item.id)
            names.push(item.name)
          }
        })
        if (this.lookPermission) {
          this.options.registerRole.forEach(item => {
            if (item.isActive) {
              ids2.push(item.key)
              names.push(item.value)
            }
          })
          this.options.technicalServiceLevel.forEach(item => {
            if (item.isActive) {
              ids3.push(item.key)
              names.push(item.value)
            }
          })
          params.content2 = JSON.stringify({ customerLevel: ids1, registerRole: ids2, technicalServiceLevel: ids3 })
        } else {
          params.content2 = JSON.stringify({ customerLevel: ids1 })
        }
        params.content = names.toString()
      }
      if (this.isGoodsGift) {
        const [goodsId, specId] = this.selectedGoodsSpec
        const goods = this.goodsList.find(item => item.id === goodsId)
        const spec = goods && goods.specValueList ? goods.specValueList.find(s => s.id === specId) : null
        let obj = {
          id: goods ? goods.id : null,
          goodsCode: goods ? goods.goodsCode : spec.jushuitanCode,
          name: goods ? goods.name : '',
          specId: spec ? spec.id : null,
          specName: spec ? spec.specName : ''
        }
        params.content = JSON.stringify(obj)
      }
      if (this.form.code === 'goodsCategoryForIP' && this.form.content) {
        params.content = params.content.length ? params.content.map(subArray => subArray[subArray.length - 1]).toString() : '';
      }
      // 处理布尔类型的会议配置，确保提交的是字符串 "1" 或 "0"
      if (this.form.code === 'meetingBaoMingZhuanPiao' || this.form.code === 'APPIsStartXianxia') {
        if (params.content === true || params.content === 'true' || params.content === 1 || params.content === '1') {
          params.content = '1'
        } else {
          params.content = '0'
        }
      }
      // 处理文件上传类型的配置（contractTemplate、coursewarePictureWatermark、HomeLiveBigPicture）
      if (this.form.code === 'contractTemplate' || this.form.code === 'coursewarePictureWatermark' || this.form.code === 'HomeLiveBigPicture') {
        // 如果 content 是数组格式，提取 url
        if (Array.isArray(params.content) && params.content.length > 0) {
          params.content = params.content[0].url || params.content[0]
        } else if (typeof params.content === 'object' && params.content !== null) {
          // 如果是对象，尝试获取 url 属性
          params.content = params.content.url || ''
        }
      }
      // 处理 MarketingPotentialShare 多图片上传，保存为逗号分隔的字符串
      if (this.form.code === 'MarketingPotentialShare') {
        if (this.marketingImages && this.marketingImages.length > 0) {
          // 只提取 url，用逗号分隔
          const urls = this.marketingImages.map(img => {
            if (typeof img === 'string') return img;
            if (img && img.url) return img.url;
            return '';
          }).filter(url => url);
          params.content = urls.join(',');
        } else {
          params.content = '';
        }
      }
      // 富文本类型的会议配置（meetingPingZhengJiaoCheng）不需要特殊处理，直接使用 content 值
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          sysDataconstantApi.update(params).then((data) => {
            this.postCallback(data)
          });
        }
      });
    },
    postCallback(data) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
    inputFile(val) {
      console.log(val)
      this.form.content = val[0].url
    }
  }
}
</script>
<style lang="scss" scoped>
.lab {
  font-size: 14px;
  color: #8f8e8e;
  border-radius: 4px;
  padding: 0 18px;
  display: inline-block;
  border: 1px solid #c5c5c5;
  margin: 5px;
  position: relative;
  cursor: pointer;
  &.active {
    background: #5dbde7;
    color: #fff;
    border-color: #5dbde7;
  }
  i {
    position: absolute;
    left: 0;
    top: 0;
  }
}
.location .el-radio {
  width: 30%;
  display: inline-block;
  margin: 10px 0;
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-cascader {
  width: 100%;
}
</style>
